import Header from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/Header/Header";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import CreatorFragment, {
  CreatorFragmentCommonProps,
  CreatorFragmentHandle,
} from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/creator-fragments/CreatorFragment";
import { AddImages } from "@coworker/apprestructured/src/task-management/components/AddImages/AddImages";
import AttachFiles from "@coworker/apprestructured/src/task-management/components/AttachFiles/AttachFiles";
import Section from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/Section/Section";
import React, { memo, ReactNode } from "react";
import CreatorFragmentConfig from "@coworker/apprestructured/src/task-management/components/TaskCreatorAndEditorSheet/creator-fragments/CreatorFragmentConfig";
import { NewOrExistingFile } from "@coworker/apprestructured/src/shared/types/newOrExistingFile";

const settingsCreatorFragments: CreatorFragmentConfig[] = [
  {
    id: "assign-to-creator-fragment",
    props: {},
  },
  {
    id: "switch-creator-fragment",
    props: {
      field: "priority",
      label: "priorityString",
      icon: "notice-circle",
    },
  },
];

interface TaskCreatorAndEditorSheetSettingsSectionProps {
  headerTitle: string;
  creatorFragmentCommonProps: CreatorFragmentCommonProps;
  scheduleComponent: ReactNode;
  images: NewOrExistingFile[];
  onImagesChange: (newImages: NewOrExistingFile[]) => void;
  isDisabled: boolean;
  files: NewOrExistingFile[];
  onFilesChange: (newFiles: NewOrExistingFile[]) => void;
  setCreatorFragmentRef?: (
    key: string
  ) => (element: CreatorFragmentHandle | null) => void;
}

export const TaskCreatorAndEditorSheetSettingsSection = memo(
  (props: TaskCreatorAndEditorSheetSettingsSectionProps) => {
    const {
      headerTitle,
      creatorFragmentCommonProps,
      setCreatorFragmentRef,
      scheduleComponent,
      images,
      onImagesChange,
      isDisabled,
      files,
      onFilesChange,
    } = props;
    return (
      <Section>
        <Header number="2" label={headerTitle} />
        <FixaListView id="settings">
          {settingsCreatorFragments.map((config) => {
            return (
              <CreatorFragment
                key={config.id}
                ref={setCreatorFragmentRef?.(config.id)}
                config={config}
                commonProps={creatorFragmentCommonProps}
              />
            );
          })}
          {scheduleComponent}
          <AddImages
            images={images}
            onConfirmClick={onImagesChange}
            disabled={isDisabled}
          />
          <AttachFiles
            disabled={isDisabled}
            files={files}
            onFilesChanged={onFilesChange}
          />
        </FixaListView>
      </Section>
    );
  }
);
